import { openTockInterstitialIfEligible } from '../reducers/tockInterstitialSlice';

const openTockUrl = (url, dispatch) => {
  if (!url || typeof window === 'undefined') return;

  if (typeof dispatch === 'function') {
    dispatch(openTockInterstitialIfEligible(url));
    return;
  }

  window.open(url, '_blank', 'noopener');
};

export default openTockUrl;
